import './PieChartPlot.css';
export var container = '_1iotdmn0-3-5-0';